<div class="sub-answer__label">
    <label class="sub-answer__labelText" [innerHtml]="subquestion.libelle"> </label>
</div>
<div class="sub-answer__input">
    <input [placeholder]="'medicalworkflow.question.day' | i18n" type="number" [id]="subquestion.id + '-' + controlId" class="textfield textfield--custom" [formControl]="myControl" />
</div>
